import React, { useRef, useEffect } from "react";
import Logo from "./components/Logo";
import Menu from "./components/Menu";
import Subscribe from "./components/Subscribe";
import Widgets from "./components/Widgets";

const Header = () => {
  const header = useRef(null);
  const toggleClass = "main-sticky";

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 200) {
        if (header.current !== null) header.current.classList.add(toggleClass);
      } else {
        if (header.current !== null)
          header.current.classList.remove(toggleClass);
      }
    });
  }, []);

  return (
    <header>
      <div className="container" ref={header} id="the-top">
        <div className="row">
          <div className="col-12">
            <Logo />
            <Menu />
          </div>
        </div>
      </div>
      <div className="bg-green bottom py-4">
        <div className="container">
          <div className="row justify-content-between">
            <Subscribe />
            <Widgets />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
